/////////////////////////////////////////////////
///          Staging                      //////
////////////////////////////////////////////////
export const environment = {
  production: true,
  apiBasePath: `https://kcdemoapi-keycloak.kloudconnect.com.au`,
  authServerUrl: `https://auth.kloudconnect.com.au`,
  apiClientPath: 'https://kcdemo-keycloak.kloudconnect.com.au',
  realm: 'kcdemo-app',
  clientId: 'frontend',
  resourceServerId: 'api',
  dmsBasePath: 'https://kcdmsstage.kloudconnect.com.au/api/',
  appInsights: {
    instrumentationKey: '57201933-75cc-457f-bc68-bbf81f183576'
  },
  azureFeatureEndPoint: 'Endpoint=https://kc-appconfig-demo.azconfig.io;Id=44dL;Secret=TiJHRqM+fVhYk1o2ouAOqmO8p6Azh/uSqHXx1Jt2IEQ=',
  syncfusionLicenseKey: "Ngo9BigBOggjHTQxAR8/V1NNaF5cXmBCf1FpRmJGdld5fUVHYVZUTXxaS00DNHVRdkdmWXtcc3RcRmRfV0VzX0tWYEo="
};
